import { Injectable } from '@angular/core';

import { BusyIndicatorService } from '../busyindicator/busyindicator.service';

@Injectable()
export class ModalBusyIndicatorGuard {
    constructor(private busyIndicatorService: BusyIndicatorService) {}

    canDeactivate() {
        return this.busyIndicatorService.hidden;
    }
}
